
import React from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';

export default function FloatingIllustration({ type = 'block', className, delay = 0, floatDuration = 3, animationType = 'float' }) {
  const { scrollYProgress } = useScroll();
  const yParallax = useTransform(scrollYProgress, [0, 1], [0, -150]);
  const opacityFade = useTransform(scrollYProgress, [0, 0.8, 1], [1, 1, 0]);

  const animations = {
    float: {
      y: [0, -20, 0],
      transition: { duration: floatDuration, repeat: Infinity, ease: "easeInOut", delay }
    },
    rotate: {
      rotate: [0, 10, -10, 0],
      transition: { duration: 4, repeat: Infinity, ease: "easeInOut", delay }
    },
    sway: {
      rotate: [-5, 5, -5],
      x: [0, 10, -10, 0],
      transition: { duration: 3.5, repeat: Infinity, ease: "easeInOut", delay }
    }
  };

  const renderSVG = () => {
    switch(type) {
      case 'block':
        return (
          <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" className="text-[hsl(var(--primary))]">
            <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/>
            <polyline points="3.27 6.96 12 12.01 20.73 6.96"/>
            <line x1="12" y1="22.08" x2="12" y2="12"/>
          </svg>
        );
      case 'car':
        return (
          <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" className="text-[hsl(var(--accent))]">
            <path d="M14 16H9m10 0h3v-3.15a1 1 0 0 0-.84-.99L16 11l-2.7-3.6a2 2 0 0 0-1.6-.8H8.3a2 2 0 0 0-1.6.8L4 11l-2.16.86A1 1 0 0 0 1 12.85V16h3M7 16a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm10 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4z"/>
          </svg>
        );
      case 'house':
        return (
          <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" className="text-[hsl(var(--secondary))]">
            <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/>
            <polyline points="9 22 9 12 15 12 15 22"/>
          </svg>
        );
      case 'pet':
        return (
          <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" className="text-[hsl(var(--natural-oak))]">
            <path d="M12 5c2 0 4 1 4 3 0 2-2 4-4 4s-4-2-4-4c0-2 2-3 4-3z"/>
            <path d="M6 14.5A4.5 4.5 0 0 0 10.5 19h3a4.5 4.5 0 0 0 4.5-4.5V14a2 2 0 0 0-2-2h-8a2 2 0 0 0-2 2v.5z"/>
          </svg>
        );
      default:
        return null;
    }
  };

  return (
    <motion.div 
      className={`absolute z-10 drop-shadow-xl ${className}`}
      style={{ y: yParallax, opacity: opacityFade }}
    >
      <motion.div animate={animations[animationType]}>
        {renderSVG()}
      </motion.div>
    </motion.div>
  );
}
